function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminportal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15385_13763)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15385_13763",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 21,
    height: 21
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.012207 0.00976753H19.9878V20.0098H-0.012207V0.00976753Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15385_13763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2773 13.3257C16.2791 13.3214 16.2809 13.3171 16.2826 13.3128C16.444 12.9221 16.8209 12.6637 17.2437 12.6637H17.6372C18.5001 12.6637 19.1997 11.9642 19.1997 11.1012V10.3199C19.1997 9.45701 18.5001 8.75744 17.6372 8.75744H17.2437C16.8209 8.75744 16.444 8.49912 16.2826 8.10834C16.2809 8.10404 16.2791 8.09975 16.2773 8.09549C16.115 7.70471 16.1984 7.25525 16.4976 6.95607L16.7758 6.67787C17.386 6.06768 17.386 5.07834 16.7758 4.46814L16.2234 3.91572C15.6132 3.30553 14.6238 3.30553 14.0137 3.91572L13.7355 4.19393C13.4363 4.49311 12.9868 4.5765 12.596 4.4142C12.5917 4.4124 12.5875 4.41064 12.5832 4.40885C12.1924 4.24752 11.934 3.87061 11.934 3.44783V3.05432C11.934 2.19139 11.2345 1.49182 10.3716 1.49182H9.59033C8.72736 1.49182 8.02783 2.19139 8.02783 3.05432V3.44783C8.02783 3.87061 7.76947 4.24752 7.37869 4.40885C7.3744 4.41064 7.37014 4.4124 7.36584 4.4142C6.97506 4.5765 6.52561 4.49311 6.22643 4.19393L5.94822 3.91572C5.33803 3.30553 4.34869 3.30553 3.7385 3.91572L3.18608 4.46814C2.57588 5.07834 2.57588 6.06768 3.18608 6.67787L3.46428 6.95607C3.7635 7.25525 3.84686 7.70471 3.68455 8.09549C3.68279 8.09975 3.681 8.10404 3.67924 8.10834C3.51787 8.49912 3.14096 8.75744 2.71818 8.75744H2.32471C1.46174 8.75744 0.762207 9.45701 0.762207 10.3199V11.1012C0.762207 11.9642 1.46174 12.6637 2.32471 12.6637H2.71818C3.14096 12.6637 3.51787 12.9221 3.67924 13.3128C3.681 13.3171 3.68279 13.3214 3.68455 13.3257",
    stroke: "#1A4338",
    style: {
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9328 18.5246C15.725 17.2057 14.6535 15.943 14.1437 15.4766C13.0651 14.4828 11.609 13.8758 10.0267 13.8758C7.16678 13.8758 4.75451 15.8586 4.12061 18.5246",
    stroke: "#1A4338",
    style: {
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.89502 10.7107C6.89502 8.9848 8.29412 7.58569 10.02 7.58569C11.7459 7.58569 13.145 8.9848 13.145 10.7107C13.145 12.4366 11.7459 13.8357 10.02 13.8357C8.29412 13.8357 6.89502 12.4366 6.89502 10.7107Z",
    stroke: "#1A4338",
    style: {
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15385_13763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminportal);
export default __webpack_public_path__ + "static/media/adminportal.9c9afc81b17db7a8384482df46feb25a.svg";
export { ForwardRef as ReactComponent };